export const PreferencesSection = () => {
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8 space-y-6">
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold text-neutral-900">Preferences</h1>
          <p className="text-sm text-neutral-600">
            Customize your personal preferences and application settings.
          </p>
        </div>

        {/* Placeholder for future preferences */}
        <section className="bg-white rounded-xl shadow-sm border border-neutral-200 p-6">
          <div className="text-center py-12">
            <p className="text-sm text-neutral-600">
              Preference settings will be available here in a future update.
            </p>
            <p className="text-xs text-neutral-500 mt-2">
              This section will include theme preferences, notification settings, and other
              user-specific configurations.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};
